import { memo } from "react";

import { type Maybe } from "@shopify/hydrogen-react/storefront-api-types";

import { Image } from "@components/Image";
import { tw } from "classnames";

type Props = {
  image: {
    altText: Maybe<string>;
    height: number;
    id: string;
    url: string;
    width: number;
  };
  lazyLoadImages: boolean;
};

const styles = {
  wrapper: tw("bg-background-secondary", "relative", "aspect-square"),
  image: tw("object-cover"),
};

const ProductGalleryGridImageBase = ({ image, lazyLoadImages }: Props) => {
  return (
    <div className={styles.wrapper}>
      <Image
        alt={image.altText ?? ""}
        className={styles.image}
        height={374}
        loading={lazyLoadImages ? "lazy" : "eager"}
        src={image.url}
        width={374}
      />
    </div>
  );
};

export const ProductGalleryGridImage = memo(ProductGalleryGridImageBase);
